import { CREATE_SAMPLE_DC_APPROVAL_DATA_FAILURE, 
    CREATE_SAMPLE_DC_APPROVAL_DATA_REQUEST,
    CREATE_SAMPLE_DC_APPROVAL_DATA_SUCCESS, 
    CREATE_USER_FORM_SAMPLE_DC_APPROVAL, 
    FETCH_SAMPLE_DC_APPROVAL_STYLE_DETAIL_FAILURE, 
    FETCH_SAMPLE_DC_APPROVAL_STYLE_DETAIL_REQUEST, 
    FETCH_SAMPLE_DC_APPROVAL_STYLE_DETAIL_SUCCESS, 
    FETCH_SAMPLE_DC_APPROVAL_STYLE_FAILURE, 
    FETCH_SAMPLE_DC_APPROVAL_STYLE_REQUEST, 
    FETCH_SAMPLE_DC_APPROVAL_STYLE_SUCCESS, 
    SAMPLE_DC_APPROVAL_USERFORM_RESET,
    FETCH_SAMPLE_DC_APPROVAL_BY_STYLE_REQUEST,
    FETCH_SAMPLE_DC_APPROVAL_BY_STYLE_SUCCESS,
    FETCH_SAMPLE_DC_APPROVAL_BY_STYLE_FAILURE,
    DELETE_SAMPLE_DC_APPROVAL_BY_ID_SUCCESS,
    DELETE_SAMPLE_DC_APPROVAL_BY_ID_REQUEST,
    DELETE_SAMPLE_DC_APPROVAL_BY_ID_FAILURE,
    SAMPLE_DC_APPROVAL_FULLFORM_RESET

} from "./sampleDcApproval.actionsType";


export const SAMPLE_DC_APPROVAL = 'sampleDC';

let initialState = {
    loading: false,
    sampleApprovalStyle: [],
    sampleApprovalStyleDetail: [],
    sampleApprovalbyStyle : [],
    userform: {
        fldFKStyle: 0,
        fldFKColour: [],
        fldFKTypeOfPo: 0,
        fldIsApplicable: 0
    }

};

export let sampleApprovalDCReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    console.log('action', action)

    switch (type) {
        case FETCH_SAMPLE_DC_APPROVAL_STYLE_REQUEST:
        case FETCH_SAMPLE_DC_APPROVAL_STYLE_DETAIL_REQUEST:
        case CREATE_SAMPLE_DC_APPROVAL_DATA_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_SAMPLE_DC_APPROVAL_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                sampleApprovalStyle: updatePayload?.Program
            };
        case CREATE_SAMPLE_DC_APPROVAL_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                detailsId: updatePayload
            };

        case CREATE_USER_FORM_SAMPLE_DC_APPROVAL:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_SAMPLE_DC_APPROVAL_STYLE_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                sampleApprovalStyleDetail: updatePayload
                
            };
        case SAMPLE_DC_APPROVAL_USERFORM_RESET:
    return {
        ...state,
        userform: {
            ...state.userform,
            fldFKColour: [],
            fldFKTypeOfPo: 0,
            fldIsApplicable: 0
        }
    };
    case SAMPLE_DC_APPROVAL_FULLFORM_RESET:
    return {
        ...state,
        userform: {
            fldFKStyle: 0,
            fldFKColour: [],
            fldFKTypeOfPo: 0,
            fldIsApplicable: 0
        }
    }
        case FETCH_SAMPLE_DC_APPROVAL_BY_STYLE_REQUEST:
            return {
                ...state,
                loading: true,                
            };
        case FETCH_SAMPLE_DC_APPROVAL_BY_STYLE_SUCCESS:
             return {
                ...state,
                loading: false,
               sampleApprovalbyStyle: updatePayload
            };
        case DELETE_SAMPLE_DC_APPROVAL_BY_ID_REQUEST:
                        return {
                            ...state,
                            loading: true
                        };
        case DELETE_SAMPLE_DC_APPROVAL_BY_ID_SUCCESS:
                         return {
        ...state,
        loading: false,
       userform: {
            ...state.userform,
            fldFKColour: []
        },
        sampleApprovalbyStyle: []
    };
        case FETCH_SAMPLE_DC_APPROVAL_BY_STYLE_FAILURE:
        case FETCH_SAMPLE_DC_APPROVAL_STYLE_FAILURE:
        case FETCH_SAMPLE_DC_APPROVAL_STYLE_DETAIL_FAILURE:
        case CREATE_SAMPLE_DC_APPROVAL_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case DELETE_SAMPLE_DC_APPROVAL_BY_ID_FAILURE:
        default:
            return state;
    }

};